const boatImages = [
  {
    original:
      "https://firebasestorage.googleapis.com/v0/b/vip-hamptons-detailing.appspot.com/o/boats%2Ftanda%201%2FIMG-20260731-WA0030.jpg?alt=media&token=582bee23-e3c6-4ed6-946f-930c95793382",
    thumbnail:
      "https://firebasestorage.googleapis.com/v0/b/vip-hamptons-detailing.appspot.com/o/boats%2Ftanda%201%2FIMG-20260731-WA0030.jpg?alt=media&token=582bee23-e3c6-4ed6-946f-930c95793382",
  },
  {
    original:
      "https://firebasestorage.googleapis.com/v0/b/vip-hamptons-detailing.appspot.com/o/boats%2Ftanda%201%2F20260701_190157.jpg?alt=media&token=2c6ae112-4f84-4d4b-b2e6-e551db9dd28e",
    thumbnail:
      "https://firebasestorage.googleapis.com/v0/b/vip-hamptons-detailing.appspot.com/o/boats%2Ftanda%201%2F20260701_190157.jpg?alt=media&token=2c6ae112-4f84-4d4b-b2e6-e551db9dd28e",
  },
  {
    original:
      "https://firebasestorage.googleapis.com/v0/b/vip-hamptons-detailing.appspot.com/o/boats%2Fgaleria%2FMesa%20de%20trabajo%201%20copia%205.jpg?alt=media&token=bdb66c78-ddc3-4381-9ed9-8a674aba78e5",
    thumbnail:
      "https://firebasestorage.googleapis.com/v0/b/vip-hamptons-detailing.appspot.com/o/boats%2Fgaleria%2FMesa%20de%20trabajo%201%20copia%205.jpg?alt=media&token=bdb66c78-ddc3-4381-9ed9-8a674aba78e5",
  },
  {
    original:
      "https://firebasestorage.googleapis.com/v0/b/vip-hamptons-detailing.appspot.com/o/boats%2Fgaleria%2FMesa%20de%20trabajo%201%20copia%205-2.jpg?alt=media&token=690c1ae4-a10d-4f31-a1a0-472bf4f6a17d",
    thumbnail:
      "https://firebasestorage.googleapis.com/v0/b/vip-hamptons-detailing.appspot.com/o/boats%2Fgaleria%2FMesa%20de%20trabajo%201%20copia%205-2.jpg?alt=media&token=690c1ae4-a10d-4f31-a1a0-472bf4f6a17d",
  },
  {
    original:
      "https://firebasestorage.googleapis.com/v0/b/vip-hamptons-detailing.appspot.com/o/boats%2Ftanda%201%2Fbotes%20(1).jpg?alt=media&token=cd475562-cb44-4a2f-85fd-5e560c7897f9",
    thumbnail:
      "https://firebasestorage.googleapis.com/v0/b/vip-hamptons-detailing.appspot.com/o/boats%2Ftanda%201%2Fbotes%20(1).jpg?alt=media&token=cd475562-cb44-4a2f-85fd-5e560c7897f9",
  },
  {
    original:
      "https://firebasestorage.googleapis.com/v0/b/vip-hamptons-detailing.appspot.com/o/boats%2Fgaleria%2FMesa%20de%20trabajo%201%20copia%204.jpg?alt=media&token=85bce7d1-5742-430d-9582-d6f2d60a88a2",
    thumbnail:
      "https://firebasestorage.googleapis.com/v0/b/vip-hamptons-detailing.appspot.com/o/boats%2Fgaleria%2FMesa%20de%20trabajo%201%20copia%204.jpg?alt=media&token=85bce7d1-5742-430d-9582-d6f2d60a88a2",
  },
  {
    original:
      "https://firebasestorage.googleapis.com/v0/b/vip-hamptons-detailing.appspot.com/o/boats%2Fgaleria%2FMesa%20de%20trabajo%201%20copia%204-2.jpg?alt=media&token=685938fe-c350-4c89-a644-631570b99759",
    thumbnail:
      "https://firebasestorage.googleapis.com/v0/b/vip-hamptons-detailing.appspot.com/o/boats%2Fgaleria%2FMesa%20de%20trabajo%201%20copia%204-2.jpg?alt=media&token=685938fe-c350-4c89-a644-631570b99759",
  },
  {
    original:
      "https://firebasestorage.googleapis.com/v0/b/vip-hamptons-detailing.appspot.com/o/boats%2Fgaleria%2FMesa%20de%20trabajo%201%20copia%204-1.jpg?alt=media&token=2c70e868-b4d8-4277-8498-26e744f17940",
    thumbnail:
      "https://firebasestorage.googleapis.com/v0/b/vip-hamptons-detailing.appspot.com/o/boats%2Fgaleria%2FMesa%20de%20trabajo%201%20copia%204-1.jpg?alt=media&token=2c70e868-b4d8-4277-8498-26e744f17940",
  },
  {
    original:
      "https://firebasestorage.googleapis.com/v0/b/vip-hamptons-detailing.appspot.com/o/boats%2Ftanda%201%2FScanned_20260925-1548-07.jpg?alt=media&token=a3bffff3-ab04-43bd-872a-9ba5468e3066",
    thumbnail:
      "https://firebasestorage.googleapis.com/v0/b/vip-hamptons-detailing.appspot.com/o/boats%2Ftanda%201%2FScanned_20260925-1548-07.jpg?alt=media&token=a3bffff3-ab04-43bd-872a-9ba5468e3066",
  },
  {
    original:
      "https://firebasestorage.googleapis.com/v0/b/vip-hamptons-detailing.appspot.com/o/boats%2Fgaleria%2FMesa%20de%20trabajo%201%20copia%203-2.jpg?alt=media&token=6697074c-3355-4273-ac23-cec6a6a3bb13",
    thumbnail:
      "https://firebasestorage.googleapis.com/v0/b/vip-hamptons-detailing.appspot.com/o/boats%2Fgaleria%2FMesa%20de%20trabajo%201%20copia%203-2.jpg?alt=media&token=6697074c-3355-4273-ac23-cec6a6a3bb13",
  },
  {
    original:
      "https://firebasestorage.googleapis.com/v0/b/vip-hamptons-detailing.appspot.com/o/boats%2Fgaleria%2FMesa%20de%20trabajo%201%20copia%203-1.jpg?alt=media&token=15a9ad31-1671-47b0-982d-8f07326c351c",
    thumbnail:
      "https://firebasestorage.googleapis.com/v0/b/vip-hamptons-detailing.appspot.com/o/boats%2Fgaleria%2FMesa%20de%20trabajo%201%20copia%203-1.jpg?alt=media&token=15a9ad31-1671-47b0-982d-8f07326c351c",
  },
   {
    original:
      "https://firebasestorage.googleapis.com/v0/b/vip-hamptons-detailing.appspot.com/o/boats%2Ftanda%201%2Ffoto1.jpg?alt=media&token=00285d54-9e80-456c-8b96-725713c67d09",
    thumbnail:
      "https://firebasestorage.googleapis.com/v0/b/vip-hamptons-detailing.appspot.com/o/boats%2Ftanda%201%2Ffoto1.jpg?alt=media&token=00285d54-9e80-456c-8b96-725713c67d09",
  },

];

export { boatImages };
